import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

// SHAPES (unchanged)
import shapeLeft from "../../images/shape/prev-shape.png";
import shapeRight from "../../images/shape/next-shape.png";

// TYPES
interface BlogItem {
  img: string;
  imgHero: string;
  tag: string;
  title: string;
  content: string;
}

interface BlogTopListProps {
  blogs: BlogItem[];
}

const BlogTopList: React.FC<BlogTopListProps> = ({ blogs }) => {
  return (
    <section className="blog pt-70">
      <div className="container">
        <div className="blog-slider pos-rel">

          <Swiper
            modules={[Navigation, Pagination]}
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            pagination={{ clickable: true }}
            navigation={{
              nextEl: ".blog-swiper-btn.swiper-button-next",
              prevEl: ".blog-swiper-btn.swiper-button-prev",
            }}
            className="swiper-container"
          >
            {blogs.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="blog-slide-item">
                  <div className="xb-item--img">
                    {/* HERO IMAGE USED HERE */}
                    <img src={item.imgHero} alt={item.title} />
                  </div>

                  <div className="xb-item--holder">
                    <span className="xb-item--tag xb-border">
                      #{item.tag}
                    </span>

                    <h2 className="xb-item--title">
                      <span>{item.title}</span>
                    </h2>

                    <p className="xb-item--content">
                      {item.content}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* PAGINATION */}
          <div className="swiper-pagination"></div>

          {/* NAV BUTTONS */}
          <div className="blog-item_button">
            <div className="blog-swiper-btn swiper-button-prev">
              <img src={shapeLeft} alt="" />
              <i className="fa-regular fa-angles-left"></i>
            </div>

            <div className="blog-swiper-btn swiper-button-next">
              <img src={shapeRight} alt="" />
              <i className="fa-regular fa-angles-right"></i>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default BlogTopList;
